import { useRef, useState } from 'react'

import Link from 'next/link'
import { Label } from '@components/UI/Form/Label'
import { Input } from '@components/UI/Form/Input'
import { Button } from '@components/UI/Button'
import { v1 } from '@services/api'
import toast from 'react-hot-toast'

export function AffiliateContactForm({ action, title, referrer, redirect }) {
  const form = useRef<any>(null)
  const [showMessage, setShowMessage] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()
    setShowMessage(false)

    async function sendContactInfo(
      name: string,
      email: string,
      message: string
    ) {
      try {
        await v1.post('/users/sendContact', { name, email, message })
        if (redirect && form?.current) {
          form.current.submit()
        } else {
          setShowMessage(true)
        }
      } catch (error) {
        toast.error('There was an error sending your information.')
      }
    }
    const data = new FormData(form.current)
    const firstName = data.get('FNAME') as string
    const lastName = data.get('LNAME') as string
    const fullName = firstName + ' ' + lastName

    const email = data.get('EMAIL') as string
    const phone = data.get('MMERGE1') as string
    const company = data.get('MMERGE2') as string

    const message = `Phone: ${phone} || Company: ${company} || Form: ${referrer}`
    void sendContactInfo(fullName, email, message)
  }

  return (
    <div className="flex flex-col items-center justify-center lg:w-full sm:w-2/3 w-full max-w-xl mx-auto lg:pt-0 pt-8 shadow-lg">
      <div className="bg-brand w-full px-8 p-4 rounded-t-lg">
        <h4 className="m-auto md:text-2xl text-lg text-white text-center font-black tracking-tight">
          {title}
        </h4>
      </div>
      <div className="bg-white w-full p-8 rounded-b-lg">
        {showMessage ? (
          <div className="relative bg-green-300 text-green-900 rounded p-4 mb-4">
            <h4 className="font-black font-heading text-2xl mb-2">
              THANK YOU!
            </h4>
            <p className="mb-2">
              We will be in touch shortly to schedule your demo and will be
              sharing additional information.
            </p>

            <p>Lee Eckroth, Majordomo CEO/Co-Founder</p>
          </div>
        ) : (
          <form
            action={action}
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            ref={form}
          >
            <section className="grid sm:grid-cols-2 grid-cols-1 gap-2 mb-4">
              <div>
                <Label htmlFor="mce-FNAME">First Name</Label>
                <Input
                  name="FNAME"
                  id="mce-FNAME"
                  type="text"
                  required
                  placeholder="First"
                />
              </div>
              <div>
                <Label htmlFor="mce-LNAME">Last Name</Label>
                <Input
                  name="LNAME"
                  id="mce-LNAME"
                  type="text"
                  required
                  placeholder="Last"
                />
              </div>
            </section>

            <section className="mb-4">
              <Label htmlFor="mce-EMAIL">Email</Label>
              <Input
                name="EMAIL"
                id="mce-EMAIL"
                type="email"
                required
                placeholder="example@example.com"
              />
            </section>

            <section className="mb-4">
              <Label htmlFor="mce-MMERGE1">Phone</Label>
              <Input
                name="MMERGE1"
                id="mce-MMERGE1"
                type="text"
                required
                placeholder="(123) 456-7890"
              />
            </section>

            <section className="mb-4">
              <Label htmlFor="mce-MMERGE1">Company</Label>
              <Input
                name="MMERGE2"
                id="mce-MMERGE2"
                type="text"
                required
                placeholder="Majordomo"
              />
            </section>

            <section className="flex flex-col items-center justify-center space-y-4">
              <Button wide onClick={handleSubmit}>
                Submit
              </Button>
              <p className="text-xs text-gray-500">
                We won’t share this information with anybody else.
              </p>
              <Link href="/privacy-policy">
                <a
                  className="text-xs text-accentBlue hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </Link>
            </section>
          </form>
        )}
      </div>
    </div>
  )
}
